import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router } from '@angular/router';
import { UserNotification } from '@interfaces/Reminder';
import { BoButtonComponent } from '@shared-components/bo-button/bo-button.component';
import { UserNotificationsService } from '@shared-services/user-notifications.service';
import { ANGULAR_IMPORTS } from 'app/shared/imports/angular.imports';
import { UserNotificationActionService } from '@shared-services/user-notification-action.service';
import {
  getUserNotificationPresentation,
  UserNotificationPresentation,
} from '@shared-services/user-notification-presentation';

@Component({
  selector: 'gd-notifications-badge',
  templateUrl: './notifications-badge.component.html',
  styleUrls: ['./notifications-badge.component.scss'],
  standalone: true,
  imports: [
    ...ANGULAR_IMPORTS,
    MatButtonModule,
    MatDividerModule,
    MatMenuModule,
    MatIconModule,
    MatBadgeModule,
    BoButtonComponent,
  ],
})
export class NotificationsBadgeComponent implements OnInit {
  notifications: UserNotification[] = [];
  unreadCount = 0;

  constructor(
    private userNotificationsService: UserNotificationsService,
    private notificationActions: UserNotificationActionService,
    private router: Router,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.userNotificationsService.loadNotifications();
    this.userNotificationsService.loadUnreadCount();
    this.userNotificationsService.notifications$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((notifications) => {
        this.notifications = notifications;
      });
    this.userNotificationsService.unreadCount$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((count) => (this.unreadCount = count));
  }

  get unreadNotificationsCount(): number {
    return this.unreadCount;
  }

  getPresentation(notif: UserNotification): UserNotificationPresentation {
    return getUserNotificationPresentation(notif);
  }

  canNavigate(notif: UserNotification): boolean {
    return this.notificationActions.canNavigate(notif);
  }

  markAsRead(notif: UserNotification): void {
    this.userNotificationsService.markAsRead(notif.id);
  }

  navigateToAction(notif: UserNotification): void {
    this.notificationActions.navigate(notif);
  }

  navigateToNotifications() {
    this.router.navigate(['/notifications']);
  }

  markAllAsRead(): void {
    this.userNotificationsService.markAllAsRead();
  }
}
